const STORE_IS_OPEN_CLASS = 'store-is-open'
const STORE_OPEN_SOON_CLASS = 'store-open-soon'
const STORE_CLOSE_CLASS = 'store-close'

const STORE_IS_OPEN_TEXT = "Ouvert"
const STORE_OPEN_SOON_TEXT = "Ouvre à "
const STORE_CLOSE_TEXT = "Fermé"

const WEEK = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']

export {
    STORE_IS_OPEN_CLASS,
    STORE_OPEN_SOON_CLASS,
    STORE_CLOSE_CLASS,
    STORE_IS_OPEN_TEXT,
    STORE_OPEN_SOON_TEXT,
    STORE_CLOSE_TEXT,
    WEEK,
}